"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeChatApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var WeChatApi = /** @class */ (function () {
    function WeChatApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     *
     * @method GET undefined
     *
     */
    WeChatApi.prototype.ticket = function () {
        return this.http
            .url("/api/WeChat/ticket")
            .support('GET');
    };
    /**
     *
     * @method GET undefined
     *
     */
    WeChatApi.prototype.signature = function () {
        return this.http
            .url("/api/WeChat/signature")
            .support('GET');
    };
    WeChatApi.diOptions = di_1.default.options({
        name: "WeChatApi",
        scope: "Singleton"
    });
    return WeChatApi;
}());
exports.WeChatApi = WeChatApi;
exports.default = WeChatApi;
